import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import '../css/PrincipalDashboard.css'; // Common dashboard styling
import axios from 'axios';

// ==========================================
// SIDEBAR SUB-COMPONENT
// ==========================================
const Sidebar = ({ viewMode }) => {
  const userRole = localStorage.getItem('role');
  const userId = localStorage.getItem('userId') || '1';
  const navigate = useNavigate();
  
  const dashboardPath = userRole === 'admin' ? '/admin' : `/admin/career-counsellor/${userId}`;

  return (
    <aside className="sidebar">
      <nav className="nav-menu">
        <Link to={dashboardPath} className="nav-item active" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <span>🏠</span> Dashboard
        </Link>
        <div className="nav-item"><span>🤝</span> Assigned Bookings</div>
        
        {/* Admin view hone par Return tab visible hoga */}
        {viewMode === 'admin' && (
          <div className="nav-item" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
            <span>⬅️</span> Return
          </div>
        )}
      </nav>
    </aside>
  );
};

// ==========================================
// MAIN CAREER COUNSELLOR DASHBOARD
// ==========================================
const CareerCounsellorDashboard = () => {
  const { id } = useParams(); // Admin route se id catch karne ke liye
  const { state } = useLocation();
  const userRole = localStorage.getItem('role');
  
  // URL mein id hai aur user admin hai, toh mode 'admin' hoga
  const currentViewMode = (id && userRole === 'admin') ? 'admin' : 'counsellor';

  const [userData, setUserData] = useState(() => {
    if (currentViewMode === 'admin') return null;
    return state?.user || JSON.parse(localStorage.getItem("user"));
  });
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Admin view ho ya data incomplete ho, toh fresh call lagao
    if (currentViewMode === 'admin' || !userData || !userData.counsellorExpertise) {
      fetchFullProfile();
    }
  }, [currentViewMode, id]);

  const fetchFullProfile = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      
      let url = 'https://api.satrixstore.in/api/me';
      if (currentViewMode === 'admin' && id) {
        url = `https://api.satrixstore.in/api/admin/user-details/${id}`;
      }

      const response = await axios.get(url, {
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      });

      const comingData = response.data.data ? response.data.data : response.data;
      setUserData(comingData);
      
      if (currentViewMode !== 'admin') {
        localStorage.setItem("user", JSON.stringify(comingData));
      }
    } catch (error) {
      console.error("Error fetching counsellor profile:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading Counsellor Dashboard...</div>;

  const user = userData || {};

  // Career Counselling Leads / Bookings (Sample Data)
  const students = [
    { id: 1, name: 'Vikram Malhotra', stream: 'Commerce', course: 'Global BBA / Study Abroad', status: 'Scheduled', location: 'Mumbai', contact: '+91 98111 22233' },
    { id: 2, name: 'Anjali Sharma', stream: 'Science (PCB)', course: 'Alternative Medicine', status: 'Completed', location: 'Delhi', contact: '+91 95555 66677' }
  ];

  return (
    <div className="principal-dashboard-root">
      <Sidebar viewMode={currentViewMode} />
      
      <div className="principal-dashboard-container">
        <div className="main-content">
          <header className="welcome-header">
            <p>Welcome back, Career Counsellor 👋</p>
            <h1>{user.fullName || user.name || "Counsellor Name"}</h1>
          </header>

          <div className="profile-hero-card">
            <div className="profile-main">
              <div className="avatar">{(user.fullName || user.name) ? (user.fullName || user.name).charAt(0) : 'CC'}</div>
              <div className="info">
                <h3>{user.fullName || user.name || "Counsellor Name"}</h3>
                <p><span>📧</span> {user.email || "counsellor@evridya.com"}</p>
                <p><span>📱</span> {user.phoneNumber || user.phone || "+91 99999 00000"}</p>
                <p><span>📍</span> {user.city || "Bangalore"}</p>
              </div>
            </div>
            
            {/* Career Counsellor Specific Metrics Grid */}
            <div className="stats-grid">
              <div className="stat-item">
                <span>🎯</span><label>Organization Name:</label> 
                <strong>{user.counsellorOrganizationName || user.expertise || "Study Abroad & Management"}</strong>
              </div>
              <div className="stat-item">
                <span>📜</span><label>Certification:</label> 
                <strong>{user.counsellorCertification || user.certification || "Global Career Counsellor (GCC)"}</strong>
              </div>
              <div className="stat-item">
                <span>📅</span><label>Sessions Conducted:</label> 
                <strong>{user.totalSessions || "120+"} Sessions</strong>
              </div>
            </div>
          </div>

          <div className="table-card">
            <div className="table-header">
              <h3>Assigned Counselling Bookings</h3>
              <div className="search-filter">
                <input type="text" placeholder="Search student..." />
              </div>
            </div>
            <table>
              <thead>
                <tr><th>#</th><th>Student Name</th><th>12th Stream</th><th>Target / Interest</th><th>Location</th><th>Status</th></tr>
              </thead>
              <tbody>
                {students.map((s, index) => (
                  <tr key={s.id}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{s.name}</strong><br /><small>{s.contact}</small>
                    </td>
                    <td>{s.stream}</td>
                    <td>{s.course}</td>
                    <td>{s.location}</td>
                    <td>
                      <span className={`status-pill ${s.status.toLowerCase().replace(' ', '-')}`}>{s.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerCounsellorDashboard;